import React from 'react';
import s from './MobileFeaturesCarousel.scss';
import { PRODUCT } from '../mobile-constant';
import MobileFeatures from '../MobileFeatures/MobileFeatures';

interface MobileFeaturesProps {
  selectedProductIndex: number;
  setSelectedProduct: (productIndex: number, buttonType: string) => void;
}

export const MobileFeaturesCarousel: React.FunctionComponent<MobileFeaturesProps> =
  (props: MobileFeaturesProps) => {
    let touchXStart: number;
    let touchXEnd: number;

    const handleTouchStart = (touchStartEvent: any) => {
      touchXStart = touchStartEvent.targetTouches[0].clientX;
    };
    const handleTouchMove = (touchMoveEvent: any) => {
      touchXEnd = touchMoveEvent.targetTouches[0].clientX;
    };
    const handleTouchEnd = () => {
      if (touchXEnd === -1) {
        touchXEnd = touchXStart;
      }
      const tenPercentOfWidth = window.innerWidth * 0.1;
      const touchXDiff = touchXEnd - touchXStart;
      if (Math.abs(touchXDiff) >= tenPercentOfWidth) {
        const swipeRight = touchXDiff > 0;
        if (swipeRight) {
          if (props.selectedProductIndex > PRODUCT.UNLIMITED) {
            props.setSelectedProduct(
              props.selectedProductIndex - 1,
              'swipe_reg',
            );
          }
        } else {
          if (props.selectedProductIndex < PRODUCT.FREE) {
            props.setSelectedProduct(
              props.selectedProductIndex + 1,
              'swipe_reg',
            );
          }
        }
      }
      touchXStart = -1;
      touchXEnd = -1;
    };

    const marginLeft = `${props.selectedProductIndex * -100}vw`;

    return (
      <div
        className={s.strip}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className={s.viewArea}
          style={{ marginLeft }}
          data-hook="mobile-features-carousel"
        >
          <MobileFeatures selectedProductIndex={PRODUCT.UNLIMITED} />
          <MobileFeatures selectedProductIndex={PRODUCT.PRO} />
          <MobileFeatures selectedProductIndex={PRODUCT.BASIC} />
          <MobileFeatures selectedProductIndex={PRODUCT.FREE} />
        </div>
      </div>
    );
  };

export default MobileFeaturesCarousel;
